import apiConfig from '@constants/apiConfig';

import DigibesDeviceDetailPage from './qrlive';
import ListQrlivePage from '.';

export default {
    listQrliveDevicePage: {
        path: '/qrlive',
        title: 'QR Live Management',
        auth: true,
        component: ListQrlivePage,
        permission: [apiConfig.device.getList.baseURL],
    },
    listQrliveDigibesDevicePage: {
        path: '/qrlive/:restaurantId/digibes',
        title: 'Digibes Device Management',
        auth: true,
        component: DigibesDeviceDetailPage,
        permission: [apiConfig.device.getList.baseURL],
    },
};